// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB0L8DdNu-qwZ-YaSSdIFfShTIj1zC_FMA",
    authDomain: "crypto-app-ab039.firebaseapp.com",
    projectId: "crypto-app-ab039",
    storageBucket: "crypto-app-ab039.appspot.com",
    messagingSenderId: "646451141602",
    appId: "1:646451141602:web:e8f5a6956ccf8848cb37bb"
  };

  export default firebaseConfig;